/* istanbul ignore file */
import { Box } from '@mui/material';
import { useFilterContext } from '../../../FilterContext';
import { useUiTheme } from 'framework/uiTheme';
import { Button } from '../../../../../ui/mui-builder/Button/Button';

interface FilterActionsProps {
  onChangeCallback: () => void;
  onResetCallback: () => void;
}

const FilterActions = ({ onChangeCallback, onResetCallback }: FilterActionsProps) => {
  const { apply } = useFilterContext();
  const { Button: ThemedButton = Button } = useUiTheme();

  return (
    <Box className="filter-actions" sx={{ padding: '16px 16px 13px' }}>
      <ThemedButton
        variant="outlined"
        onClick={() => {
          onChangeCallback();
          apply();
        }}
        sx={{ fontSize: '14px', marginRight: '7px' }}
        className="update-filter-item-button"
      >
        Update
      </ThemedButton>
      <ThemedButton
        variant="text"
        onClick={onResetCallback}
        sx={{ fontSize: '14px' }}
        className="reset-filter-item-button"
      >
        Cancel
      </ThemedButton>
    </Box>
  );
};

export default FilterActions;
